// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Z7Jr","selected":"styles_selected__vyJkV"};